import React, { PropTypes } from 'react'
import CSSModules from 'react-css-modules'
import { Relayout, RelayoutItem, RelayoutWrapper } from 'relayout'

import { CONTACT_US_MODAL } from 'constants/modal-constants'

import styles from './footer.css'
import { URLS } from '../../constants/url-constants'
import LogoIcon from '../../../assets/icons/to-logo-black.svg'

const Footer = ({ showModal }) => (
  <div styleName="footer">
    <RelayoutWrapper>
      <Relayout align="center">
        <RelayoutItem>
          <div>
            <div styleName="footer-row"><LogoIcon /></div>
            <div styleName="footer-row">
              <a href={URLS.shopTerms} styleName="link" target="_blank" rel="noopener noreferrer">
                Terms and conditions
              </a>
              <span styleName="separator">·</span>
              <a // eslint-disable-line jsx-a11y/no-static-element-interactions
                onClick={() => showModal(CONTACT_US_MODAL)}
                styleName="link"
              >
                Contact Us
              </a>
            </div>
            <div styleName="footer-row">
              © {new Date().getFullYear()} Time Out England Limited and affiliated companies owned by
              Time Out Group Plc. All rights reserved. Time Out is a registered trademark of Time Out
              Digital Limited.
            </div>
          </div>
        </RelayoutItem>
      </Relayout>
    </RelayoutWrapper>
  </div>
)

Footer.propTypes = {
  showModal: PropTypes.func,
}

export default CSSModules(Footer, styles)



/** WEBPACK FOOTER **
 ** ./src/components/footer/footer.js
 **/